import type { ReactNode } from 'react';
import {
  surfaceHeaderProps,
  type SurfaceBelow,
  type SurfacePadding,
} from './surface-header';

/** The header band as a wrapper, for a title made of several elements. A title
 *  that is already one row takes `surfaceHeaderProps` directly instead. */
export function SurfaceHeader({
  padding,
  below,
  children,
}: Readonly<{
  padding: SurfacePadding;
  below?: SurfaceBelow;
  children: ReactNode;
}>) {
  return <div {...surfaceHeaderProps(padding, below)}>{children}</div>;
}
